import script from "./DeleteOrFreezeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteOrFreezeModal.vue?vue&type=script&setup=true&lang=js"

import "./DeleteOrFreezeModal.vue?vue&type=style&index=0&id=76964d57&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76964d57"]])

export default __exports__